import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker' 
import logout from '../../Global/logout' 

export default async function putTaxRate(
    uuid,
    label,
    description,
    tax_rate,
    country,
    note
) {
    const unHashedJwt = await checkJwt()    

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/taxRate/' + uuid + '?countryUuid=' + country, {
            method: 'put',
            headers: { 
                'Authorization' : unHashedJwt                 
            },
            data: {
                "label": label,
                "description": description,
                "tax_rate": tax_rate,
                "note": note
            }      
        }).then(res => res)
        .catch(error => error.response.data.status === 401 ? logout() : error.response.data)
        );
}